import Service from './abstract';
import usersService from './users';
import platforms from '../constants/users/platforms';
import FLOW_TYPES from '../constants/auth/flowTypes';

const defaultPlatform = platforms.backoffice;

class Login extends Service {
    constructor () {
        super('auth');
    }

    login (email, password, captchaToken) {
        return this.post({
            url: `${this.basePath}/login?with=${usersService.fullWith}`,
            data: {
                idPlatform: defaultPlatform,
                captchaToken,
                payload: { email, password }
            }
        })
            .then(res => usersService.normalize(res));
    }

    // Update the status from blocked to recovery
    recover (id, idPlatform) {
        return this.post({
            url: `${this.basePath}/recover`,
            data: {
                idToken: id, // otp. idUser no va más?
                idUser: id,
                idPlatform: idPlatform
            }
        });
    }

    recoverUser (id) {
        return this.post({
            url: `${this.basePath}/recover/user`,
            data: {
                idToken: id,
                idUser: id
            }
        });
    }

    register (data) {
        const options = {
            url: `${this.basePath}/register`,
            data
        };

        return this.post(options)
            .then(res => {
                return this.post({
                    url: `${this.basePath}/verify`,
                    data: {
                        idPlatform: defaultPlatform,
                        email: data.person.emails[0].email,
                        metadata: {
                            flowType: FLOW_TYPES.ONBOARDING,
                            user: {
                                id: res.id,
                                fullname: data.fullname
                            },
                            subject: 'Natura | Verificación de cuenta',
                            url: `https://${window.location.host}/auth/otp?flowType=${FLOW_TYPES.ONBOARDING}`
                        }
                    }
                });
            });
    }

    validate (data) {
        return this.post({
            url: `${this.basePath}/validate`,
            data
        });
    }

    validateForgot (data) {
        return this.post({
            url: `${this.basePath}/password/forgot/validate`,
            data
        });
    }

    change (data) {
        return this.post({
            url: `${this.basePath}/password/recover`,
            data
        });
    }

    forgot (data) {
        return this.post({
            url: `${this.basePath}/password/forgot`,
            data
        });
    }

    resendPassword (data) {
        return this.post({
            url: `${this.basePath}/password/resend`,
            data
        });
    }
}

export default new Login();
